import React from 'react';


export default function Nav() {
  return (
    <nav>
      <div className="nav-container">
        <h1>Asin Sakthivel</h1>
        <div>
          <a href="#home">Home</a>
          <a href="#about">About</a>
          <a href="#projects">Projects</a>
          <a href="#contact">Contact</a>
        </div>
      </div>
    </nav>
  );
}
